// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
//
// AuthCallback — mounted at /auth/callback. When Emergent Google Auth
// redirects here the URL fragment contains `#session_id=<sid>`. We exchange
// it with our backend and navigate the user to their intended destination.
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    const nextParam = new URLSearchParams(location.search).get("next");
    const next = nextParam && nextParam.startsWith("/") ? nextParam : "/marketplace";

    if (!sid) {
      navigate(next, { replace: true });
      return;
    }

    (async () => {
      try {
        const r = await axios.post(`${API}/auth/session`, null, {
          headers: { "X-Session-ID": sid },
        });
        setUser(r.data);
        // If the caller did not force a specific destination, an approved
        // coach lands on their dashboard. Regular clients keep going to the
        // marketplace. This mirrors what a coach actually wants after login.
        const isGenericLanding = !nextParam || next === "/marketplace" || next === "/";
        if (isGenericLanding) {
          try {
            const cr = await axios.get(`${API}/coach/me`);
            if (cr.data?.is_coach && cr.data?.is_approved) {
              navigate("/coach-dashboard", { replace: true });
              return;
            }
          } catch { /* ignore — fall through to default next */ }
        }
      } catch (err) {
        // fall through — user will land unauthenticated
        console.error("Auth exchange failed", err);
      }
      // Clean the URL and go to the intended destination.
      navigate(next, { replace: true });
    })();
  }, [location, navigate, setUser]);

  return (
    <div data-testid="auth-callback" className="min-h-screen grid place-items-center bg-white">
      <div className="text-center">
        <Loader2 className="w-6 h-6 text-slate-400 animate-spin mx-auto" />
        <p className="mt-4 text-[13px] text-slate-500 font-medium">Signing you in…</p>
      </div>
    </div>
  );
}
